import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { DevExtremeModule } from 'devextreme-angular';
import { IboxtoolsModule } from '../common/iboxtools/iboxtools.module';
import { baseZIndex } from 'devextreme/ui/overlay';
import { Options as dxDataGridOptions, default as dxDataGrid } from 'devextreme/ui/data_grid';
import { Options as dxTreeListOptions, default as dxTreeList } from 'devextreme/ui/tree_list';
import { Options as dxFormOptions, default as dxForm } from 'devextreme/ui/form';
import { Options as dxSelectBoxOptions, default as dxSelectBox } from 'devextreme/ui/select_box';
import { BsModalRef, BsModalService, ModalModule, ModalOptions } from 'ngx-bootstrap/modal';
import { HrefDirective } from './href.directive';
import { RouterModule } from '@angular/router';
import { InputDialogComponent } from './input-dialog/input-dialog.component';
import { SelectDialogComponent } from './select-dialog/select-dialog.component';
import { ListDialogComponent } from './list-dialog/list-dialog.component';
import { DetailDialogComponent } from './detail-dialog/detail-dialog.component';
import { Workbook } from 'exceljs';
import * as saveAs from 'file-saver';
import { exportDataGrid } from 'devextreme/excel_exporter';

export { InputDialogComponent };

export class CustomBsModalService extends BsModalService {
    show(content: any, config?: ModalOptions): BsModalRef {
      if (!config) config = {};
      config.id = (new Date()).getUTCMilliseconds();
      return super.show(content, config);
    }
  }

@NgModule({
    imports: [CommonModule, FormsModule, ModalModule.forRoot(), RouterModule, DevExtremeModule, IboxtoolsModule],
    declarations: [HrefDirective, InputDialogComponent, SelectDialogComponent, ListDialogComponent, DetailDialogComponent],
    exports: [DevExtremeModule, IboxtoolsModule, HrefDirective, InputDialogComponent, SelectDialogComponent, ListDialogComponent, DetailDialogComponent],
    providers: [
        { provide: BsModalService, useClass: CustomBsModalService },
    ]
})
export class SharedModule {
    public static onToolbarPreparing(e) {
        e.toolbarOptions.items.unshift(
            {
                location: 'before',
                template: 'toolbarButtons',
            },
            {
                widget: 'dxButton',
                options: {
                    icon: 'revert',
                    elementAttr: { title: 'Reset Filters' },
                    onClick: () => {
                        e.component.clearFilter();
                    },
                },
                location: 'after',
            }
        );
    }

    constructor() {
        const dataGridOptions: dxDataGridOptions = {
            // height: '100%',
            height: '100px' /* hack default value to make scrolling work */,
            // width: '100px',
            width: '100%',
            columnAutoWidth: true,
            columnResizingMode: 'widget',
            allowColumnReordering: true,
            allowColumnResizing: true,
            hoverStateEnabled: false,
            showBorders: false,
            showColumnLines: false,
            showRowLines: true,
            paging: { enabled: false, pageSize: 50 },
            scrolling: { mode: 'virtual', showScrollbar: 'always', preloadEnabled: true },
            selection: { mode: 'single', showCheckBoxesMode: 'onLongTap' },
            stateStoring: { savingTimeout: 800 },
            filterRow: { applyFilter: 'auto' },
            focusedRowEnabled: false,
            onExporting: SharedModule.onExporting,
        };
        dxDataGrid.defaultOptions({ options: dataGridOptions });

        const treeListOptions: dxTreeListOptions = {
            // height: '100px',
            width: '100%',
            allowColumnResizing: true,
            columnResizingMode: 'widget',
            showBorders: true,
            hoverStateEnabled: false,
            selection: { mode: 'single' },
            stateStoring: { savingTimeout: 800 },
        };
        dxTreeList.defaultOptions({ options: treeListOptions });

        const formOptions: dxFormOptions = {
            showColonAfterLabel: false,
            labelLocation: 'left',
            // labelLocation: 'top',

        };
        dxForm.defaultOptions({ options: formOptions });

        const selectboxOptions: dxSelectBoxOptions = {
            searchEnabled: true,
            searchTimeout: 100,
            showClearButton: false,
            inputAttr: { autoComplete: false },
            onFocusIn: (e) => {
                const inputs = e.element.getElementsByTagName('input');
                inputs.item(inputs.length - 1).select();
            },
        };
        dxSelectBox.defaultOptions({ options: selectboxOptions });

        baseZIndex(3000);
    }

    public static async onExporting(e, fileName: string = 'export', worksheetName: string = 'Data') {
        const workbook = new Workbook();
        const worksheet = workbook.addWorksheet(worksheetName);
        await exportDataGrid({ component: e.component, worksheet: worksheet });
        const buffer = await workbook.xlsx.writeBuffer();
        saveAs(new Blob([buffer], { type: 'application/octet-stream' }), `${fileName}.xlsx`);
    }
}
